import { Link } from "react-router-dom"
import { ModalContent } from "./ModalContent"
import { createRef, useEffect, useState } from "react";
import { CreateToast, getOfferWindowStatus } from "../../components/utils";
import { socket } from "../../components/Containers/MainContainer";
import ReCAPTCHA from "react-google-recaptcha";

export const FaucetModalContent = (props) => {
    const [captchaInstance, setCaptchaInstance] = useState(null);
    const [earnState, setEarnState] = useState({ token: '' })
    const creaRef = createRef();
    const [offerWindowFull, setOfferWindowFull] = useState(getOfferWindowStatus());
    
    useEffect(() => {
        setOfferWindowFull(getOfferWindowStatus())
    }, [])
    
    const [isAdBlocker, setAdBlocker] = useState(false);
    const [adViewCount, setAdViewCount] = useState(0);
    
    // Ad blocker detection
    useEffect(() => {
        const detectAdBlocker = () => {
            const testAd = document.createElement('div');
            testAd.innerHTML = '&nbsp;';
            testAd.className = 'adsbox';
            testAd.style.position = 'absolute';
            testAd.style.left = '-10000px';
            document.body.appendChild(testAd);
            
            setTimeout(() => {
                if (testAd.offsetHeight === 0) {
                    setAdBlocker(true);
                }
                document.body.removeChild(testAd);
            }, 100);
        };
        
        detectAdBlocker();
    }, []);
    
    useEffect(() => {
        socket.on('resetcapthca_login', () => {
            captchaRef.current.reset();
        })
    }, [])
    
    const [timer, setTimer] = useState(21);
    const [timerMessage, setTimerMessage] = useState("Wait 8s");
    const [update, setUpdate] = useState(false);
    const [CanRun, setCanRun] = useState(false)
    const [page, setPage] = useState(0)
    const captchaRef = createRef();
    const [faucetData, setFaucetData] = useState({})
    
    useEffect(function () {
        socket.on('good_capthca_faucet', () => {
            setPage(2)
        })
        
        if (CanRun == true) {
            setTimeout(function () {
                setTimer(timer - 1);
                if (timer > 8) {
                    setTimerMessage(getTime(faucetData.time))
                } else {
                    setTimerMessage(`Wait ${timer}s`)
                }
                if (timer > 0) {
                    setUpdate(update == true ? false : true);
                }
            }, 1000 * 1)
        }
    }, [update])
    
    const [canWait, setCanWait] = useState();
    
    useEffect(() => {
        socket.on('faucetData', (data) => {
            setCanWait(data.canWait)
            setTimeout(() => {
                if (data.canWait == true) {
                    setTimer(50)
                    setTimerMessage(data.time)
                    setFaucetData(faucetData);
                    setCanRun(false)
                } else {
                    setTimer(8)
                    setTimerMessage("Wait 8s")
                    setPage(0)
                    setCanRun(true)
                    setUpdate(update == true ? false : true)
                }
            }, 1000)
        })
        socket.emit('emitFaucetData')
    }, [])

    // Track ad interactions for revenue optimization
    const handleAdInteraction = (adId) => {
        setAdViewCount(prev => prev + 1);
        // Track ad engagement analytics
        socket.emit('adInteraction', { adId, timestamp: Date.now() });
    };

    return (
        <ModalContent 
            click={props.click}
            hideTitle={true}
            hide={!props.show}
            title={props.title} 
            className={`modal-content-${props.modalSize} faucet-modal`}
            content={
                <>
                    <div className="faucet-container">
                        {/* Top Ad Banner - More Prominent */}
                        <div className="ad-section top-ads">
                            <EnhancedAd 
                                position="top" 
                                onInteraction={() => handleAdInteraction('top-1')} 
                            />
                        </div>

                        {/* Main Content Area */}
                        <div className="main-content">
                            {/* Left Sidebar Ad */}
                            <div className="ad-sidebar left">
                                <SidebarAd 
                                    position="left" 
                                    onInteraction={() => handleAdInteraction('sidebar-left')} 
                                />
                            </div>

                            {/* Central Faucet Card */}
                            <div className="faucet-card">
                                <div className="card-header">
                                    <div className="coin-icon">💰</div>
                                    <h1>Free Coin Faucet</h1>
                                    <div className="reward-badge">
                                        Up to 100 coins + 1 XP
                                    </div>
                                </div>

                                {isAdBlocker ? (
                                    <AdBlockerWarning />
                                ) : (
                                    <FaucetContent 
                                        page={page}
                                        setPage={setPage}
                                        timer={timer}
                                        setTimer={setTimer}
                                        timerMessage={timerMessage}
                                        setTimerMessage={setTimerMessage}
                                        CanRun={CanRun}
                                        setCanRun={setCanRun}
                                        update={update}
                                        setUpdate={setUpdate}
                                        captchaRef={captchaRef}
                                        earnState={earnState}
                                        creaRef={creaRef}
                                        socket={socket}
                                        onAdInteraction={handleAdInteraction}
                                    />
                                )}

                                {/* Inline Ad between steps */}
                                {page === 1 && (
                                    <div className="inline-ad">
                                        <InlineAd onInteraction={() => handleAdInteraction('inline')} />
                                    </div>
                                )}
                            </div>

                            {/* Right Sidebar Ad */}
                            <div className="ad-sidebar right">
                                <SidebarAd 
                                    position="right" 
                                    onInteraction={() => handleAdInteraction('sidebar-right')} 
                                />
                            </div>
                        </div>

                        {/* Bottom Ad Section */}
                        <div className="ad-section bottom-ads">
                            <EnhancedAd 
                                position="bottom" 
                                onInteraction={() => handleAdInteraction('bottom-1')} 
                            />
                        </div>

                        {/* Floating Video Ad (appears after delay) */}
                        {adViewCount > 2 && (
                            <FloatingVideoAd onInteraction={() => handleAdInteraction('video')} />
                        )}
                    </div>

                    <style jsx>{`
                        .faucet-container {
                            width: 100%;
                            min-height: 100vh;
                            background: linear-gradient(135deg, #1a2332 0%, #2d3748 100%);
                            display: flex;
                            flex-direction: column;
                            position: relative;
                        }

                        .ad-section {
                            width: 100%;
                            display: flex;
                            justify-content: center;
                            padding: 10px;
                            background: rgba(0,0,0,0.1);
                        }

                        .top-ads {
                            border-bottom: 1px solid rgba(255,255,255,0.1);
                        }

                        .bottom-ads {
                            border-top: 1px solid rgba(255,255,255,0.1);
                            margin-top: auto;
                        }

                        .main-content {
                            display: flex;
                            flex: 1;
                            align-items: center;
                            justify-content: center;
                            padding: 20px;
                            gap: 20px;
                        }

                        .ad-sidebar {
                            width: 160px;
                            height: 600px;
                            display: flex;
                            flex-direction: column;
                            gap: 20px;
                        }

                        .faucet-card {
                            background: linear-gradient(145deg, #2d3748 0%, #4a5568 100%);
                            border-radius: 20px;
                            padding: 30px;
                            box-shadow: 
                                0 20px 40px rgba(0,0,0,0.3),
                                inset 0 1px 0 rgba(255,255,255,0.1);
                            border: 1px solid rgba(255,255,255,0.1);
                            max-width: 400px;
                            width: 100%;
                            text-align: center;
                            position: relative;
                            overflow: hidden;
                        }

                        .faucet-card::before {
                            content: '';
                            position: absolute;
                            top: 0;
                            left: -100%;
                            width: 100%;
                            height: 100%;
                            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent);
                            animation: shine 3s infinite;
                        }

                        @keyframes shine {
                            0% { left: -100%; }
                            100% { left: 100%; }
                        }

                        .card-header {
                            margin-bottom: 25px;
                        }

                        .coin-icon {
                            font-size: 48px;
                            margin-bottom: 10px;
                            filter: drop-shadow(0 0 10px #ffd700);
                        }

                        .card-header h1 {
                            color: #fff;
                            margin: 0 0 15px 0;
                            font-size: 28px;
                            font-weight: 700;
                            text-shadow: 0 2px 4px rgba(0,0,0,0.5);
                        }

                        .reward-badge {
                            background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
                            color: white;
                            padding: 8px 16px;
                            border-radius: 20px;
                            font-size: 14px;
                            font-weight: 600;
                            display: inline-block;
                            box-shadow: 0 4px 8px rgba(72, 187, 120, 0.3);
                        }

                        .claim-button {
                            background: linear-gradient(135deg, #21838a 0%, #17525a 100%);
                            border: none;
                            border-radius: 12px;
                            color: #fff;
                            padding: 15px 30px;
                            font-size: 16px;
                            font-weight: 600;
                            cursor: pointer;
                            transition: all 0.3s ease;
                            box-shadow: 0 6px 12px rgba(33, 131, 138, 0.3);
                            text-transform: uppercase;
                            letter-spacing: 1px;
                        }

                        .claim-button:hover:not(:disabled) {
                            transform: translateY(-2px);
                            box-shadow: 0 8px 16px rgba(33, 131, 138, 0.4);
                        }

                        .claim-button:disabled {
                            opacity: 0.6;
                            cursor: not-allowed;
                            background: #4a5568;
                        }

                        .inline-ad {
                            margin: 20px 0;
                            padding: 15px;
                            border: 1px dashed rgba(255,255,255,0.2);
                            border-radius: 8px;
                        }

                        .timer-display {
                            color: #e2e8f0;
                            font-size: 18px;
                            margin: 15px 0;
                            font-weight: 500;
                        }

                        @media (max-width: 768px) {
                            .main-content {
                                flex-direction: column;
                            }
                            
                            .ad-sidebar {
                                width: 100%;
                                height: auto;
                                flex-direction: row;
                                overflow-x: auto;
                            }
                            
                            .faucet-card {
                                margin: 20px 0;
                            }
                        }
                    `}</style>
                </>
            }
        />
    )
}

// Enhanced Ad Component with Better Revenue Optimization
function EnhancedAd({ position, onInteraction }) {
    const [currentAd, setCurrentAd] = useState(0);
    const [viewTime, setViewTime] = useState(0);
    
    const ads = [
        { id: '2188243', size: '728x90' },
        { id: '2188245', size: '728x90' },
        { id: '2407129', size: '728x90' }, // Additional ad slots
    ];

    useEffect(() => {
        // Rotate ads more frequently for better revenue
        const interval = setInterval(() => {
            setCurrentAd(prev => (prev + 1) % ads.length);
            onInteraction();
        }, 15000 + Math.random() * 10000); // 15-25 seconds

        return () => clearInterval(interval);
    }, []);

    // Track view time for analytics
    useEffect(() => {
        const timer = setInterval(() => {
            setViewTime(prev => prev + 1);
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="enhanced-ad" data-view-time={viewTime}>
            <iframe 
                data-aa={ads[currentAd].id}
                src={`//ad.a-ads.com/${ads[currentAd].id}?size=${ads[currentAd].size}`}
                style={{
                    width: '728px',
                    height: '90px',
                    border: '0px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                }}
                onLoad={onInteraction}
            />
        </div>
    );
}

// Sidebar Ad Component
function SidebarAd({ position, onInteraction }) {
    const [adIndex, setAdIndex] = useState(0);
    
    const sidebarAds = [
        { id: '2407130', size: '160x600' },
        { id: '2407130', size: '160x600' },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setAdIndex(prev => (prev + 1) % sidebarAds.length);
            onInteraction();
        }, 20000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="sidebar-ad">
            <iframe 
                data-aa={sidebarAds[adIndex].id}
                src={`//ad.a-ads.com/${sidebarAds[adIndex].id}?size=${sidebarAds[adIndex].size}`}
                style={{
                    width: '160px',
                    height: '600px',
                    border: '0px',
                    borderRadius: '8px'
                }}
                onLoad={onInteraction}
            />
        </div>
    );
}

// Inline Ad Component
function InlineAd({ onInteraction }) {
    return (
        <div className="inline-ad-content">
            <p style={{ color: '#a0aec0', fontSize: '12px', margin: '0 0 10px 0' }}>
                Advertisement
            </p>
            <iframe 
                data-aa="2407129"
                src="//ad.a-ads.com/2407129?size=300x250"
                style={{
                    width: '300px',
                    height: '250px',
                    border: '0px',
                    borderRadius: '8px'
                }}
                onLoad={onInteraction}
            />
        </div>
    );
}

// Floating Video Ad
function FloatingVideoAd({ onInteraction }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
            onInteraction();
        }, 30000); // Show after 30 seconds

        return () => clearTimeout(timer);
    }, []);

    if (!isVisible) return null;

    return (
        <div className="floating-video-ad">
            <div className="video-ad-container">
                <button 
                    className="close-video-ad"
                    onClick={() => setIsVisible(false)}
                >
                    ×
                </button>
                <iframe 
                    data-aa="2407129"
                    src="//ad.a-ads.com/2407129?size=300x200"
                    style={{
                        width: '300px',
                        height: '200px',
                        border: '0px',
                        borderRadius: '8px'
                    }}
                />
            </div>
            
            <style jsx>{`
                .floating-video-ad {
                    position: fixed;
                    bottom: 20px;
                    right: 20px;
                    z-index: 1000;
                    animation: slideIn 0.5s ease-out;
                }

                .video-ad-container {
                    position: relative;
                    background: #2d3748;
                    border-radius: 12px;
                    padding: 10px;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.3);
                }

                .close-video-ad {
                    position: absolute;
                    top: -5px;
                    right: -5px;
                    background: #e53e3e;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 25px;
                    height: 25px;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 1;
                }

                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
}

// Ad Blocker Warning Component
function AdBlockerWarning() {
    return (
        <div className="adblocker-warning">
            <div className="warning-icon">🚫</div>
            <h3>Ad Blocker Detected</h3>
            <p>
                Please disable your ad blocker and refresh the page to claim free coins. 
                Ads help us keep this service free!
            </p>
            <button 
                className="refresh-button"
                onClick={() => window.location.reload()}
            >
                Refresh Page
            </button>
            
            <style jsx>{`
                .adblocker-warning {
                    text-align: center;
                    padding: 20px;
                    color: #e2e8f0;
                }

                .warning-icon {
                    font-size: 48px;
                    margin-bottom: 15px;
                }

                .adblocker-warning h3 {
                    color: #f56565;
                    margin-bottom: 15px;
                }

                .refresh-button {
                    background: #48bb78;
                    color: white;
                    border: none;
                    padding: 10px 20px;
                    border-radius: 8px;
                    cursor: pointer;
                    margin-top: 15px;
                }
            `}</style>
        </div>
    );
}

// Main Faucet Content Component
function FaucetContent({ 
    page, setPage, timer, setTimer, timerMessage, setTimerMessage,
    CanRun, setCanRun, update, setUpdate, captchaRef, earnState, 
    creaRef, socket, onAdInteraction 
}) {
    const handleClaim = (e) => {
        if (timer <= -1 && timer != -699) {
            if (page === 0) {
                setPage(1);
                setTimer(8);
                setTimerMessage("Wait 8s");
                setCanRun(true);
                setUpdate(!update);
                onAdInteraction(); // Track interaction
            } else if (page === 1) {
                if (captchaRef.current.getValue().length > 5) {
                    e.target.innerText = "Claiming...";
                    setPage(2);
                    socket.emit('userAction', {
                        action: 'claim_faucet',
                        token: captchaRef.current.getValue(),
                    });
                    onAdInteraction(); // Track successful claim
                } else {
                    CreateToast('Captcha is invalid', creaRef, 1);
                }
            }
        } else {
            e.preventDefault();
        }
    };

    return (
        <div className="faucet-content">
            {page === 0 && (
                <>
                    <p className="description">
                        Claim up to 100 coins & 1 XP every 30 minutes completely free!
                    </p>
                    <div className="timer-display">{timerMessage}</div>
                </>
            )}

            {page === 1 && (
                <>
                    <ReCAPTCHA
                        sitekey="6LeE9VsjAAAAAJ4T3_cd2KhZlrpm09CqY2x3rVZc"
                        ref={captchaRef}
                        theme="dark"
                    />
                    <div className="timer-display">{timerMessage}</div>
                </>
            )}

            {page === 2 && (
                <div className="success-message">
                    <div className="success-icon">🎉</div>
                    <h3>Congratulations!</h3>
                    <p>Come back in 30 minutes for your next claim!</p>
                </div>
            )}

            <button 
                className="claim-button"
                onClick={handleClaim}
                disabled={timer > -1 && timer !== -699}
            >
                {page === 0 ? (timer <= -1 ? "Start Faucet" : timerMessage) :
                 page === 1 ? (timer <= -1 ? "Claim Free Coins" : timerMessage) :
                 "Claimed Successfully"}
            </button>

            <style jsx>{`
                .faucet-content {
                    color: #e2e8f0;
                }

                .description {
                    margin-bottom: 20px;
                    font-size: 16px;
                    line-height: 1.5;
                }

                .success-message {
                    text-align: center;
                    margin: 20px 0;
                }

                .success-icon {
                    font-size: 48px;
                    margin-bottom: 15px;
                }

                .success-message h3 {
                    color: #48bb78;
                    margin-bottom: 10px;
                }
            `}</style>
        </div>
    );
}

const getTime = (time) => {
    let date = new Date(time);
    let minutes = date.getMinutes() > 30 ? date.getMinutes() - 30 : date.getMinutes();
    let newTime = minutes + ":" + date.getSeconds().toString().padStart(2, '0');
    return newTime;
}